export const getSingleAsset = (data, id, isClone = false) => {
  const asset = data.find((item) => item?.assetid === id);
  if (!asset) {
    return {};
  }
  //console.log("getSingleAsset asset deviceprofile: ", asset?.deviceprofile);
  return {
    selectedStep: 1,
    step1: {
      errors: {
        assetName: false,
      },
      assetName: isClone ? "" : asset?.assetname,
      description: asset?.description || "",
    },
    step2: {
      errors: {
        deviceType: false,
        deviceId: false,
        deviceProfile: false,
      },
      deviceTypes: [],
      deviceNames: [],
      deviceProfiles: [],
      deviceType: asset?.devicetype || "",
      deviceId: isClone ? {id:  "", name: "Select device name" } : { id: asset?.deviceid || "", name: asset?.devicename || "" },
      deviceProfile: isClone ? {id:  "", name: "Select device profile" } : { id: asset?.deviceprofile?.id || "", name: asset?.deviceprofile?.profilename || "" },
    },
    step3: {
      location: asset?.location || {},
      locationZone: asset?.locationzone || "",
      assetType: asset?.assettype || "",
      assetModel: asset?.assetmodel || "",
      assetSerialNumber: asset?.assetserialnumber || "",
      assetOwner: asset?.assetowner || "",
    },
  };
};
export default getSingleAsset;
